import React, { useState, useEffect } from "react";
import { Dropdown, Modal, Tabs, Tab } from "react-bootstrap";
import "../../App.css";
import { FaPencilAlt } from "react-icons/fa";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import { SlCalender } from "react-icons/sl";
import { MdFolderCopy } from "react-icons/md";
import { Button } from "@mui/material";
import {
  VscTriangleLeft,
  VscTriangleRight,
} from "react-icons/vsc";

import { RiDraftLine } from "react-icons/ri";
import { GrStatusGood } from "react-icons/gr";
import { MdOutlineQrCodeScanner } from "react-icons/md";
import { LiaTruckPickupSolid } from "react-icons/lia";
import { MdWindow } from "react-icons/md";
import { TbAlertOctagonFilled } from "react-icons/tb";
import {
  FaToggleOn,
  FaToggleOff,
} from "react-icons/fa";

import Homeleft from "./homeleft.js";
import Homeright from "./homeright.js";

import {
  useNavigate,
  Link,
} from "react-router-dom";

import { MdOutlineContentCopy } from "react-icons/md";

// Card icons
import { GrDeliver } from "react-icons/gr";
import { TiDownloadOutline } from "react-icons/ti";
import { LuPackage2 } from "react-icons/lu";
import { BiTask } from "react-icons/bi";
import { MdOutlineLaunch } from "react-icons/md";

const Home = () => {
  // =====================================================
  // STATES (all unchanged)
  // =====================================================

  const [currentWeekStart, setCurrentWeekStart] =
    useState(getCurrentWeekStart());

  const [showModals, setShowModals] =
    useState(false);

  const [showEventModal, setShowEventModal] =
    useState(false);

  const [key, setKey] =
    useState("cases");

  const [casesData, setCasesData] =
    useState([]);

  // ✅ "loading" is now only used for the FIRST load of the page
  const [loading, setLoading] =
    useState(true);

  const [error, setError] =
    useState(null);

  const [selectedEventDate, setSelectedEventDate] =
    useState(null);

  const [hoveredCase, setHoveredCase] =
    useState(null);

  const [popupPosition, setPopupPosition] =
    useState({
      x: 0,
      y: 0,
    });

  const [userLabId, setUserLabId] =
    useState(null);

  const [userName, setUserName] =
    useState("");

  const [userRole, setUserRole] =
    useState("");

  const [showSaturday, setShowSaturday] =
    useState(false);

  const navigate = useNavigate();

  // =====================================================
  // USER DATA (unchanged)
  // =====================================================

  useEffect(() => {
    const labId =
      localStorage.getItem("userLabId");

    const name =
      localStorage.getItem("userName");

    const role =
      localStorage.getItem("userRole");

    const saturdayPreference =
      localStorage.getItem("showSaturday");

    if (labId) {
      setUserLabId(labId);
    } else {
      setError(
        "User Lab ID not found. Please login again."
      );
      setLoading(false);
    }

    if (name) {
      setUserName(name);
    } else {
      setUserName("User");
    }

    if (role) {
      setUserRole(role);
    } else {
      setUserRole("");
    }

    if (saturdayPreference !== null) {
      setShowSaturday(
        saturdayPreference === "true"
      );
    }
  }, []);

  // =====================================================
  // FETCH CASES
  // ✅ FIX: no setLoading(true) here any more. That was
  // replacing the whole page with "Loading dashboard..."
  // every time Saturday was toggled / week was changed
  // (the glitch). Data now refreshes in the background.
  // =====================================================

  useEffect(() => {
    if (userLabId) {
      fetchCasesData();
    }
  }, [
    userLabId,
    currentWeekStart,
    showSaturday,
  ]);

  const fetchCasesData = async () => {
    try {
      const startDate =
        formatDate(currentWeekStart);

      const endOfWeek =
        new Date(currentWeekStart);

      const daysToAdd =
        showSaturday ? 6 : 5;

      endOfWeek.setDate(
        currentWeekStart.getDate() +
          daysToAdd
      );

      const endDate =
        formatDate(endOfWeek);

      const url =
        `https://hms.backend.hiragroupcloud.com/api/cases/lab-cases/${userLabId}?startDate=${startDate}&endDate=${endDate}`;

      const response =
        await fetch(url);

      if (!response.ok) {
        throw new Error(
          `HTTP error! status: ${response.status}`
        );
      }

      const data =
        await response.json();

      let fetchedCases = [];

      if (
        data.success &&
        Array.isArray(data.data)
      ) {
        fetchedCases = data.data;
      } else if (
        Array.isArray(data)
      ) {
        fetchedCases = data;
      } else if (
        data &&
        data.data &&
        Array.isArray(data.data)
      ) {
        fetchedCases = data.data;
      }

      setCasesData(
        fetchedCases
      );

      setError(null);

      setLoading(false);
    } catch (error) {
      setError(error.message);
      setCasesData([]);
      setLoading(false);
    }
  };

  // =====================================================
  // SATURDAY (unchanged)
  // =====================================================

  const toggleSaturday = () => {
    const newValue =
      !showSaturday;

    setShowSaturday(newValue);

    localStorage.setItem(
      "showSaturday",
      newValue.toString()
    );
  };

  // =====================================================
  // WEEK START (unchanged)
  // =====================================================

  function getCurrentWeekStart() {
    const date =
      new Date();

    const day =
      date.getDay();

    const diff =
      day === 0
        ? -6
        : 1 - day;

    date.setDate(
      date.getDate() + diff
    );

    date.setHours(
      0,
      0,
      0,
      0
    );

    return date;
  }

  // =====================================================
  // PREVIOUS WEEK (unchanged)
  // =====================================================

  const prevWeek = () => {
    const prevWeekStart =
      new Date(
        currentWeekStart
      );

    prevWeekStart.setDate(
      currentWeekStart.getDate() -
        7
    );

    setCurrentWeekStart(
      prevWeekStart
    );
  };

  // =====================================================
  // NEXT WEEK (unchanged)
  // =====================================================

  const nextWeek = () => {
    const nextWeekStart =
      new Date(
        currentWeekStart
      );

    nextWeekStart.setDate(
      currentWeekStart.getDate() +
        7
    );

    setCurrentWeekStart(
      nextWeekStart
    );
  };

  // =====================================================
  // FORMAT DATE (unchanged)
  // =====================================================

  const formatDate = (date) => {
    if (!date) return "";

    const d =
      new Date(date);

    if (
      isNaN(d.getTime())
    ) {
      return "";
    }

    const year =
      d.getFullYear();

    const month =
      String(
        d.getMonth() + 1
      ).padStart(2, "0");

    const day =
      String(
        d.getDate()
      ).padStart(2, "0");

    return `${year}-${month}-${day}`;
  };

  // =====================================================
  // SAME DATE (unchanged)
  // =====================================================

  const isSameDate = (
    date1,
    date2
  ) => {
    if (
      !date1 ||
      !date2
    ) {
      return false;
    }

    const d1 =
      new Date(date1);

    const d2 =
      new Date(date2);

    if (
      isNaN(d1.getTime()) ||
      isNaN(d2.getTime())
    ) {
      return false;
    }

    return (
      d1.getFullYear() ===
        d2.getFullYear() &&
      d1.getMonth() ===
        d2.getMonth() &&
      d1.getDate() ===
        d2.getDate()
    );
  };

  // =====================================================
  // CASE COUNTS (unchanged)
  // =====================================================

  const getCasesCountForDate = (
    date
  ) => {
    if (
      loading ||
      !Array.isArray(casesData)
    ) {
      return 0;
    }

    return casesData.filter(
      (caseItem) => {
        if (!caseItem) {
          return false;
        }

        const caseDate =
          caseItem.date ||
          caseItem.start_date;

        return isSameDate(
          caseDate,
          date
        );
      }
    ).length;
  };

  const getArriveCountForDate = (
    date
  ) => {
    if (
      loading ||
      !Array.isArray(casesData)
    ) {
      return 0;
    }

    return casesData.filter(
      (caseItem) => {
        if (
          !caseItem ||
          !caseItem.arrive_date
        ) {
          return false;
        }

        return isSameDate(
          caseItem.arrive_date,
          date
        );
      }
    ).length;
  };

  const getShipCountForDate = (
    date
  ) => {
    if (
      loading ||
      !Array.isArray(casesData)
    ) {
      return 0;
    }

    return casesData.filter(
      (caseItem) => {
        if (
          !caseItem ||
          !caseItem.delivery_date
        ) {
          return false;
        }

        return isSameDate(
          caseItem.delivery_date,
          date
        );
      }
    ).length;
  };

  const getDeliveryCountForDate = (
    date
  ) => {
    if (
      loading ||
      !Array.isArray(casesData)
    ) {
      return 0;
    }

    return casesData.filter(
      (caseItem) => {
        if (
          !caseItem ||
          !caseItem.delivery_date
        ) {
          return false;
        }

        return isSameDate(
          caseItem.delivery_date,
          date
        );
      }
    ).length;
  };

  // =====================================================
  // SLIDER
  // ✅ FIX: visible cards follow the Saturday toggle
  // (5 = Mon-Fri, 6 = Mon-Sat) so the Saturday card is
  // actually visible instead of hidden behind the slider.
  // =====================================================

  const daysToShow =
    showSaturday
      ? 6
      : 5;

  const settings = {
    infinite: false,
    speed: 500,

    slidesToShow: daysToShow,

    slidesToScroll: 1,

    centerMode: false,

    centerPadding: "0px",

    arrows: false,

    variableWidth: false,

    adaptiveHeight: false,
  };

  // =====================================================
  // WEEK DATA
  // ✅ FIX: Mon-Fri (off) / Mon-Sat (on)
  // =====================================================

  const generateWeekData = () => {
    const startOfWeek =
      currentWeekStart;

    const weekData = [];

    for (
      let i = 0;
      i < daysToShow;
      i++
    ) {
      const date =
        new Date(
          startOfWeek
        );

      date.setDate(
        startOfWeek.getDate() +
          i
      );

      const today =
        new Date();

      const isToday =
        isSameDate(
          date,
          today
        );

      weekData.push({
        date,

        isToday,

        events: [
          {
            label:
              "New Cases",

            count:
              getCasesCountForDate(
                date
              ),

            icon: (
              <LuPackage2
                size={20}
              />
            ),
          },

          {
            label:
              "Arrive",

            count:
              getArriveCountForDate(
                date
              ),

            icon: (
              <TiDownloadOutline
                size={20}
              />
            ),
          },

          {
            label:
              "Ship",

            count:
              getShipCountForDate(
                date
              ),

            icon: (
              <MdOutlineLaunch
                size={20}
              />
            ),
          },

          {
            label:
              "Tasks",

            count: 0,

            icon: (
              <BiTask
                size={20}
              />
            ),
          },

          {
            label:
              "Deliveries",

            count:
              getDeliveryCountForDate(
                date
              ),

            icon: (
              <GrDeliver
                size={20}
              />
            ),
          },
        ],
      });
    }

    return weekData;
  };

  const weekData =
    generateWeekData();

  // =====================================================
  // MODAL FUNCTIONS (unchanged)
  // =====================================================

  const handleShows = () => {
    setShowModals(true);
  };

  const handleClosed = () => {
    setShowModals(false);
  };

  const handleShowEventModal = (
    tabKey,
    eventDate
  ) => {
    setKey(tabKey);
    setSelectedEventDate(
      eventDate
    );
    setShowEventModal(true);
  };

  const handleCloseEventModal =
    () => {
      setShowEventModal(false);
    };

  // =====================================================
  // EVENT CLICK (unchanged)
  // =====================================================

  const handleEventClick = (
    event,
    date
  ) => {
    const dateString =
      formatDate(date);

    if (!dateString) {
      return;
    }

    if (
      event.label ===
      "New Cases"
    ) {
      navigate(
        "/report-result",
        {
          state: {
            selectedDate:
              dateString,

            cases: [],

            fromHome: true,
          },
        }
      );
    } else if (
      event.label ===
      "Deliveries"
    ) {
      navigate(
        "/addshipping",
        {
          state: {
            selectedPeriod:
              "Today",

            dateRange: {
              startDate:
                dateString,

              endDate:
                dateString,
            },

            todayDeliveryCases:
              casesData.filter(
                (c) =>
                  c.delivery_date &&
                  isSameDate(
                    c.delivery_date,
                    date
                  )
              ),

            type:
              "Deliveries Only",

            shipper:
              "All",
          },
        }
      );
    } else if (
      event.label ===
      "Arrive"
    ) {
      handleShowEventModal(
        "cases",
        date
      );
    } else if (
      event.label ===
      "Ship"
    ) {
      handleShowEventModal(
        "shipping",
        date
      );
    } else if (
      event.label ===
      "Tasks"
    ) {
      handleShowEventModal(
        "tasks",
        date
      );
    }
  };

  // =====================================================
  // HOVER (unchanged)
  // =====================================================

  const handleMouseEnter = (
    event,
    caseItem
  ) => {
    setHoveredCase(
      caseItem
    );

    setPopupPosition({
      x: event.clientX,
      y: event.clientY,
    });
  };

  const handleMouseLeave = () => {
    setHoveredCase(null);
  };

  // =====================================================
  // WELCOME (unchanged)
  // =====================================================

  const getWelcomeMessage =
    () => {
      const capitalizedRole =
        userRole
          ? userRole
              .charAt(0)
              .toUpperCase() +
            userRole.slice(1)
          : "";

      return `Welcome ${capitalizedRole} ${userName}`;
    };

  // =====================================================
  // LOADING (first load only now)
  // =====================================================

  if (loading) {
    return (
      <div
        style={{
          padding: "20px",
          textAlign:
            "center",
        }}
      >
        <h2>
          Loading dashboard...
        </h2>
      </div>
    );
  }

  // =====================================================
  // ERROR (unchanged)
  // =====================================================

  if (error) {
    return (
      <div
        style={{
          padding: "20px",
          textAlign:
            "center",
          color: "red",
        }}
      >
        <h2>
          Error loading data
        </h2>

        <p>{error}</p>

        <button
          onClick={() =>
            fetchCasesData()
          }
        >
          Retry
        </button>
      </div>
    );
  }

  // =====================================================
  // MAIN UI
  // =====================================================

  return (
    <>
      {/* =================================================
          WELCOME + ACTIONS
      ================================================= */}

      <div
        className="home-top-section"
        style={{
          width: "95%",
          padding: 0,
          margin:
            "0 auto",
        }}
      >
        <div className="row">
          <div className="col-md-9">
            <h2 className="home-welcome-title">
              {getWelcomeMessage()}
            </h2>
          </div>

          <div className="col-md-3 home-actions-wrapper">
            <Dropdown>
              <Dropdown.Toggle
                variant="primary"
                id="dropdown-basic"
                className="home-actions-button"
                style={{
                  backgroundColor: "#004aad",
                  borderColor: "#004aad",
                  color: "white",
                  marginLeft: "70%",
                  fontSize: "15px",
                  padding: "10px 10px",
                  height: "35px",
                  minHeight: "35px",
                  lineHeight: "1",
                }}
              >
                <FaPencilAlt
                  style={{
                    marginRight: "2px",
                    fontSize: "14px",
                  }}
                />

                Actions
              </Dropdown.Toggle>

              <Dropdown.Menu>
                <Dropdown.Item href="/accountDetails">
                  <RiDraftLine
                    style={{
                      marginRight:
                        "5px",

                      fontSize:
                        "20px",
                    }}
                  />

                  New Case
                </Dropdown.Item>

               <Dropdown.Item href="/completeTasks" disabled>
                  <GrStatusGood
                    style={{
                      marginRight:
                        "5px",

                      fontSize:
                        "20px",
                    }}
                  />

                  Complete Tasks
                </Dropdown.Item>

                <Dropdown.Item
                  onClick={
                    handleShows
                  }
                   disabled
                >
                  <MdOutlineQrCodeScanner
                    style={{
                      marginRight:
                        "5px",

                      fontSize:
                        "20px",
                    }}
                  />

                  Location Scan
                </Dropdown.Item>

                <Dropdown.Item href="/newCasePickup" disabled>
                  <LiaTruckPickupSolid
                    style={{
                      marginRight:
                        "5px",

                      fontSize:
                        "20px",
                    }}
                  />

                  New Case Pickup
                </Dropdown.Item>

               <Dropdown.Item href="/Driverpage" disabled>
                  <LiaTruckPickupSolid
                    style={{
                      marginRight:
                        "5px",

                      fontSize:
                        "20px",
                    }}
                  />

                  Driver UI
                </Dropdown.Item>

               <Dropdown.Item href="/LotDispensing" disabled>
                  <MdWindow
                    style={{
                      marginRight:
                        "5px",

                      fontSize:
                        "20px",
                    }}
                  />

                  Lot Dispensing
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          </div>
        </div>
      </div>

      {/* =================================================
          LOCATION MODAL
      ================================================= */}

      <Modal
        show={showModals}
        onHide={handleClosed}
        size="lg"
      >
        <Modal.Header
          closeButton
        >
          <Modal.Title>
            Location Scan
          </Modal.Title>
        </Modal.Header>

        <Modal.Body />
      </Modal>

      {/* =================================================
          EVENTS HEADER
      ================================================= */}

      <div
        className="home-events-header"
        style={{
          display:
            "flex",

          alignItems:
            "center",

          justifyContent:
            "space-between",

          backgroundColor:
            "#004aad",

          borderRadius:
            "3px",

          padding:
            "10px",

          color:
            "white",

          width:
            "95%",

          margin:
            "0 auto",
        }}
      >
        <h5
          style={{
            margin:
              "0",

            display:
              "flex",

            alignItems:
              "center",
          }}
        >
          <SlCalender
            className="home-events-icon"
            style={{
              marginRight:
                "10px",

              fontSize:
                "25px",
            }}
          />

          <strong>
            EVENTS
          </strong>
        </h5>

        <div
          className="home-saturday-toggle"
          onClick={
            toggleSaturday
          }
          style={{
            cursor:
              "pointer",

            display:
              "flex",

            alignItems:
              "center",

            gap:
              "8px",
          }}
          title={
            showSaturday
              ? "Hide Saturday"
              : "Show Saturday"
          }
        >
          <span>
            Saturday
          </span>

          {showSaturday ? (
            <FaToggleOn />
          ) : (
            <FaToggleOff />
          )}
        </div>
      </div>

      {/* =================================================
          RESPONSIVE CSS (unchanged)
      ================================================= */}

      <style>
        {`

          /* ==========================================
             BASE SLIDER
          ========================================== */

          .slider-container {
            width: 100%;
            position: relative;
            overflow: hidden;
            box-sizing: border-box;
          }

          .slider-container .slick-slider {
            width: 100%;
          }

          .slider-container .slick-list {
            width: 100%;
            overflow: hidden;
            margin: 0 !important;
            padding: 8px 0 !important;
          }

          .slider-container .slick-track {
            display: flex !important;
            align-items: stretch;
          }

          .slider-container .slick-slide {
            padding: 5px !important;
            box-sizing: border-box;
          }

          .slider-container .slick-slide > div {
            width: 100%;
            height: 100%;
          }

          .slider-container .card {
            width: 100% !important;
            min-width: 0 !important;
            max-width: 100% !important;
            height: 100%;
            overflow: hidden;
            box-sizing: border-box;
              padding: 0 !important;
  margin: 0 !important;
          }

          .slider-container .card-header {
            min-width: 0;
            overflow: hidden;
          }

          .slider-container .card-header span {
            min-width: 0;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }

          .slider-container .button-color {
            min-width: 0;
            width: 100%;
            max-width: 100%;
            overflow: hidden;
            white-space: nowrap;
          }

          .slider-container .button-color span:last-child {
            min-width: 0;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }

          /* ==========================================
             GLANCE & ALERTS BOXES – ALWAYS SIDE BY SIDE
             (the same row class is reused for the content
              below the headers so both columns line up)
          ========================================== */

          .glance-alerts-row {
            display: flex !important;
            flex-direction: row !important;
            justify-content: space-between !important;
            width: 95% !important;
            margin: 0 auto !important;
            padding: 0px !important;
            gap: 10px !important;
            flex-wrap: nowrap !important;
          }

          .glance-box {
            display: flex !important;
            align-items: center !important;
            background-color: #004aad !important;
            border-radius: 3px !important;
            padding: 10px !important;
            color: white !important;
            flex: 1 !important;
            min-width: 0 !important;
          }

          .glance-alerts-title {
            margin: 0 !important;
            display: flex !important;
            align-items: center !important;
            white-space: nowrap !important;
          }

          .glance-alerts-icon {
            margin-right: 10px !important;
            font-size: 25px !important;
            flex-shrink: 0 !important;
          }

          /* ==========================================
             TABLET / LAPTOP
          ========================================== */

          @media (max-width: 1024px) {

            .slider-container .slick-slide {
              padding: 4px !important;
            }

            .slider-container .card-header {
              padding: 6px 7px !important;
              font-size: 11px !important;
            }

            .slider-container .card-header svg {
              width: 15px;
              height: 15px;
              flex-shrink: 0;
            }

            .slider-container .card > div:last-child {
              padding: 4px !important;
            }

            .slider-container .button-color {
              padding: 3px 3px !important;
              gap: 2px !important;
              font-size: 9px !important;
            }

            .slider-container .button-color svg {
              width: 12px;
              height: 12px;
              flex-shrink: 0;
            }

            .home-welcome-title {
              font-size: 22px;
            }

            .home-actions-button {
              font-size: 12px !important;
              padding: 6px 10px !important;
            }

            /* GLANCE & ALERTS BOXES */
            .glance-alerts-row {
              width: 95% !important;
              gap: 10px !important;
            }
            .glance-box {
              padding: 8px !important;
            }
            .glance-alerts-title {
              font-size: 1rem !important;
            }
            .glance-alerts-icon {
              font-size: 20px !important;
              margin-right: 8px !important;
            }
          }

          /* ==========================================
             MOBILE
          ========================================== */

          @media (max-width: 767px) {

            .home-top-section {
              width: 95% !important;
            }

            .home-top-section .row {
              display: flex !important;
              align-items: center !important;
              margin: 0 !important;
            }

            .home-top-section .col-md-9 {
              width: 65% !important;
              padding: 0 !important;
            }

            .home-top-section .col-md-3 {
              width: 35% !important;
              padding: 0 !important;
            }

            .home-welcome-title {
              font-size: 16px !important;
            
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
            }

            .home-actions-wrapper {
              display: flex;
              justify-content: flex-end;
            }

            .home-actions-button {
              margin-left: 0 !important;
              font-size: 10px !important;
              padding: 4px 7px !important;
              height: 28px !important;
              min-height: 28px !important;
              line-height: 1 !important;
              margin-bottom:5px;
            }

            .home-actions-button svg {
              font-size: 9px !important;
              margin-right: 2px !important;
            }

            /* EVENTS */

            .home-events-header {
              padding: 6px 8px !important;
            }

            .home-events-header h5 {
              font-size: 11px !important;
            }

            .home-events-header .home-events-icon {
              font-size: 17px !important;
              margin-right: 5px !important;
            }

            .home-saturday-toggle {
              gap: 3px !important;
            }

            .home-saturday-toggle span {
              font-size: 8px !important;
            }

            .home-saturday-toggle svg {
              font-size: 18px !important;
            }

            /* SLIDER */

            .slider-container .slick-slide {
              padding: 2px !important;
            }

            .slider-inner {
              padding-left: 7px !important;
              padding-right: 7px !important;
            }

            .slider-container .card {
              border-radius: 3px !important;
            }

            .slider-container .card-header {
              padding: 4px 3px !important;
              min-height: 22px !important;
              font-size: 7px !important;
            }

            .slider-container .card-header svg {
              width: 9px !important;
              height: 9px !important;
            }

            .slider-container .card > div:last-child {
              padding: 2px !important;
            }

            .slider-container .button-color {
              padding: 2px 1px !important;
              gap: 1px !important;
              font-size: 6px !important;
              line-height: 1 !important;
            }

            .slider-container .button-color svg {
              width: 7px !important;
              height: 7px !important;
            }

            /* ARROWS */

            .slider-button {
              width: 19px !important;
              height: 25px !important;
              min-width: 19px !important;
              padding: 0 !important;
            }

            .slider-button svg {
              font-size: 10px !important;
            }

            /* ===== GLANCE & ALERTS BOXES - ALWAYS SIDE BY SIDE ===== */
            .glance-alerts-row {
              width: 95% !important;
              flex-direction: row !important;
              flex-wrap: nowrap !important;
              gap: 8px !important;
            }
            .glance-box {
              flex: 1 !important;
              padding: 6px 8px !important;
              min-width: 0 !important;
            }
            .glance-alerts-title {
              font-size: 0.7rem !important;
              white-space: nowrap !important;
            }
            .glance-alerts-icon {
              font-size: 16px !important;
              margin-right: 5px !important;
              flex-shrink: 0 !important;
            }
          }

          /* ==========================================
             VERY SMALL MOBILE
          ========================================== */

          @media (max-width: 480px) {

            .home-top-section .col-md-9 {
              width: 62% !important;
            }

            .home-top-section .col-md-3 {
              width: 38% !important;
            }

            .home-welcome-title {
              font-size: 12px !important;
             
            }

            .home-actions-button {
              font-size: 7px !important;
              padding: 3px 5px !important;
              height: 23px !important;
              min-height: 23px !important;
              border-radius: 3px !important;
            }

            .home-actions-button svg {
              font-size: 7px !important;
            }

            /* EVENTS */

            .home-events-header {
              padding: 4px 6px !important;
            }

            .home-events-header h5 {
              font-size: 8px !important;
            }

            .home-events-header .home-events-icon {
              font-size: 12px !important;
              margin-right: 3px !important;
            }

            .home-saturday-toggle span {
              font-size: 6px !important;
            }

            .home-saturday-toggle svg {
              font-size: 14px !important;
            }

            /* CARDS */

            .slider-inner {
              padding-left: 5px !important;
              padding-right: 5px !important;
            }

            .slider-container .slick-slide {
              padding: 1px !important;
            }

            .slider-container .card-header {
              padding: 3px 2px !important;
              min-height: 17px !important;
              font-size: 5px !important;
            }

            .slider-container .card-header svg {
              width: 7px !important;
              height: 7px !important;
            }

            .slider-container .card > div:last-child {
              padding: 1px !important;
            }

            .slider-container .button-color {
              padding: 1.5px 0.5px !important;
              gap: 1px !important;
              font-size: 4.8px !important;
              line-height: 1 !important;
            }

            .slider-container .button-color svg {
              width: 5.5px !important;
              height: 5.5px !important;
            }

            /* ARROWS */

            .slider-button {
              width: 16px !important;
              height: 21px !important;
              min-width: 16px !important;
            }

            .slider-button svg {
              font-size: 8px !important;
            }

            /* ===== GLANCE & ALERTS BOXES - ALWAYS SIDE BY SIDE ===== */
            .glance-alerts-row {
              width: 95% !important;
              gap: 5px !important;
              flex-direction: row !important;
              flex-wrap: nowrap !important;
            }
            .glance-box {
              flex: 1 !important;
              padding: 4px 6px !important;
              min-width: 0 !important;
            }
            .glance-alerts-title {
              font-size: 0.55rem !important;
              white-space: nowrap !important;
            }
            .glance-alerts-icon {
              font-size: 12px !important;
              margin-right: 3px !important;
              flex-shrink: 0 !important;
            }
          }
        `}
      </style>

      {/* =================================================
          WEEKLY EVENTS SLIDER
      ================================================= */}

      <div
        style={{
          width: "95%",
          padding: 0,
          margin: "0 auto",
        }}
      >
        <div
          className="slider-container"
          style={{
            position:
              "relative",
          }}
        >
          {/* LEFT ARROW */}

          <Button
            variant="contained"
            color="primary"
            className="slider-button"
            style={{
              position:
                "absolute",

              top: "50%",

              left: "-5px",

              transform:
                "translateY(-50%)",

              height: "35px",

              width: "30px",

              padding: 0,

              minWidth:
                "unset",

              backgroundColor:
                "#004aad",

              zIndex: 10,
            }}
            onClick={
              prevWeek
            }
          >
            <VscTriangleLeft />
          </Button>

          {/* SLIDER */}

          <div
            className="slider-inner"
            style={{
              padding:
                "0 20px",
              boxSizing:
                "border-box",
            }}
          >
            <Slider
              key={`${currentWeekStart.getTime()}-${showSaturday}`}
              {...settings}
            >
              {weekData.map(
                (
                  item,
                  i
                ) => (
                  <div
                    key={i}
                  >
                    <div
                      className="card"
                      style={{
                        backgroundColor:
                          "#fff",

                        borderColor:
                          item.isToday
                            ? "#004aad"
                            : "#ddd",

                        color:
                          "#004aad",

                        margin:
                          "0",

                        border:
                          item.isToday
                            ? "2px solid #004aad"
                            : "1px solid #ddd",

                        borderRadius:
                          "4px",
                      }}
                    >
                      {/* CARD HEADER */}

                      <div
                        className="card-header"
                        style={{
                          display:
                            "flex",

                          alignItems:
                            "center",

                          justifyContent:
                            "space-between",

                          backgroundColor:
                            item.isToday
                              ? "#004aad"
                              : "#f8f9fa",

                          color:
                            item.isToday
                              ? "#fff"
                              : "#333",

                          padding:
                            "8px 12px",

                          borderBottom:
                            "1px solid #ddd",

                          borderRadius:
                            "4px 4px 0 0",

                          boxSizing:
                            "border-box",
                        }}
                      >
                        <span>
                          {item.date
                            .toString()
                            .slice(
                              0,
                              15
                            )}
                        </span>

                        <MdOutlineContentCopy
                          style={{
                            cursor:
                              "pointer",
                            flexShrink:
                              0,
                          }}
                          onClick={() =>
                            handleShowEventModal(
                              "cases",
                              item.date
                            )
                          }
                          title="View Events"
                        />
                      </div>

                      {/* EVENTS */}

                      <div
                        style={{
                          padding:
                            "8px",
                          boxSizing:
                            "border-box",
                        }}
                      >
                        {item.events.map(
                          (
                            event,
                            idx
                          ) => (
                            <button
                              key={
                                idx
                              }
                              className="button-color"
                              onClick={() =>
                                handleEventClick(
                                  event,
                                  item.date
                                )
                              }
                              style={{
                                display:
                                  "flex",

                                alignItems:
                                  "center",

                                gap:
                                  "6px",

                                background:
                                  "transparent",

                                border:
                                  "none",

                                cursor:
                                  "pointer",

                                color:
                                  "#004aad",

                                padding:
                                  "4px 8px",

                                width:
                                  "100%",

                                textAlign:
                                  "left",

                                boxSizing:
                                  "border-box",
                              }}
                            >
                              <span
                                style={{
                                  color:
                                    "#004aad",

                                  display:
                                    "flex",

                                  alignItems:
                                    "center",

                                  flexShrink:
                                    0,
                                }}
                              >
                                {
                                  event.icon
                                }
                              </span>

                              <span>
                                {
                                  event.label
                                }
                                :{" "}
                                {
                                  event.count
                                }
                              </span>
                            </button>
                          )
                        )}
                      </div>
                    </div>
                  </div>
                )
              )}
            </Slider>
          </div>

          {/* RIGHT ARROW */}

          <Button
            variant="contained"
            color="primary"
            className="slider-button"
            style={{
              position:
                "absolute",

              top: "50%",

              right: "-5px",

              transform:
                "translateY(-50%)",

              height: "35px",

              width: "30px",

              padding: 0,

              minWidth:
                "unset",

              backgroundColor:
                "#004aad",

              zIndex: 10,
            }}
            onClick={
              nextWeek
            }
          >
            <VscTriangleRight />
          </Button>
        </div>
      </div>

      {/* =================================================
          AT A GLANCE + ALERTS HEADERS
      ================================================= */}

      <div className="glance-alerts-row">
        <div className="glance-box">
          <h5 className="glance-alerts-title">
            <MdFolderCopy className="glance-alerts-icon" />
            <strong>At a Glance</strong>
          </h5>
        </div>

        <div className="glance-box">
          <h5 className="glance-alerts-title">
            <TbAlertOctagonFilled className="glance-alerts-icon" />
            <strong>Alerts & Activity</strong>
          </h5>
        </div>
      </div>

      {/* =================================================
          LEFT + RIGHT CONTENT
          Same row/geometry as the headers above
          (95% width, 10px gap, two equal columns) so
          Homeleft starts under "At a Glance" (left edge)
          and Homeright starts under "Alerts & Activity"
          (its own column's left edge).
      ================================================= */}

      <div
        className="glance-alerts-row"
        style={{ alignItems: "flex-start" }}
      >
        <div style={{ flex: 1, minWidth: 0 }}>
          <Homeleft />
        </div>

        <div style={{ flex: 1, minWidth: 0 }}>
          <Homeright />
        </div>
      </div>

      {/* =================================================
          HOVER POPUP
      ================================================= */}

      {hoveredCase && (
        <div
          style={{
            position:
              "fixed",

            top:
              popupPosition.y +
              10,

            left:
              popupPosition.x +
              10,

            backgroundColor:
              "white",

            border:
              "1px solid #ccc",

            borderRadius:
              "4px",

            padding:
              "15px",

            boxShadow:
              "0 4px 15px rgba(0,0,0,0.2)",

            zIndex:
              9999,

            width:
              "200px",

            fontSize:
              "14px",

            lineHeight:
              "1.5",
          }}
        >
          <div
            style={{
              display:
                "flex",

              alignItems:
                "center",
            }}
          >
            <span
              style={{
                marginRight:
                  "5px",
              }}
            >
              Case{" "}
              <span
                style={{
                  color:
                    "#004aad",

                  fontSize:
                    "12px",
                }}
              >
                #
                {hoveredCase.case_id ||
                  hoveredCase._id}
              </span>
            </span>

            <span
              style={{
                marginRight:
                  "5px",
              }}
            >
              for
            </span>

            <img
              src="/logo1.jpg"
              alt="Logolab"
              style={{
                width:
                  "40px",

                height:
                  "auto",
              }}
            />
          </div>

          <div>
            <span
              style={{
                color:
                  "#004aad",

                fontSize:
                  "12px",
              }}
            >
              {hoveredCase.last_name ||
                ""}
            </span>

            <span
              style={{
                marginLeft:
                  "5px",
              }}
            >
              for
            </span>
          </div>

          <div
            style={{
              marginBottom:
                "8px",
            }}
          >
            <span
              style={{
                color:
                  "#004aad",

                fontSize:
                  "12px",
              }}
            >
              {hoveredCase.account_name ||
                hoveredCase.account_holder ||
                "Unknown Account"}
            </span>
          </div>

          {/* PROCEDURES */}

          {hoveredCase.procedures &&
            hoveredCase.procedures
              .length > 0 && (
              <div
                style={{
                  marginBottom:
                    "8px",
                }}
              >
                {hoveredCase.procedures.map(
                  (
                    procedure,
                    index
                  ) => (
                    <div
                      key={
                        index
                      }
                      style={{
                        marginBottom:
                          "8px",

                        padding:
                          "5px",
                      }}
                    >
                      <div
                        style={{
                          color:
                            "gray",

                          fontSize:
                            "12px",
                        }}
                      >
                        {
                          procedure.procedure
                        }
                      </div>

                      {procedure.teeth && (
                        <div
                          style={{
                            color:
                              "gray",

                            fontSize:
                              "11px",
                          }}
                        >
                          <strong>
                            Teeth:
                          </strong>{" "}
                          {
                            procedure.teeth
                          }
                        </div>
                      )}

                      {procedure.shade && (
                        <div
                          style={{
                            color:
                              "gray",

                            fontSize:
                              "11px",
                          }}
                        >
                          <strong>
                            Shade:
                          </strong>{" "}
                          {
                            procedure.shade
                          }
                        </div>
                      )}

                      {procedure.alloyMaterial && (
                        <div
                          style={{
                            color:
                              "gray",

                            fontSize:
                              "11px",
                          }}
                        >
                          <strong>
                            Material:
                          </strong>{" "}
                          {
                            procedure.alloyMaterial
                          }
                        </div>
                      )}
                    </div>
                  )
                )}
              </div>
            )}

          {/* FALLBACK */}

          {(!hoveredCase.procedures ||
            hoveredCase.procedures
              .length === 0) &&
            hoveredCase.workRequested && (
              <div
                style={{
                  marginBottom:
                    "8px",
                }}
              >
                <span
                  style={{
                    color:
                      "#004aad",

                    fontSize:
                      "12px",

                    fontWeight:
                      "bold",
                  }}
                >
                  {
                    hoveredCase.workRequested
                  }
                </span>
              </div>
            )}
        </div>
      )}

      {/* =================================================
          EVENTS MODAL
      ================================================= */}

      <Modal
        show={
          showEventModal
        }
        onHide={
          handleCloseEventModal
        }
        centered
        dialogClassName="custom-modal-dialog"
      >
        <Modal.Header
          style={{
            backgroundColor:
              "#004aad",

            color:
              "white",
          }}
        >
          <Modal.Title>
            Events
          </Modal.Title>

          <button
            onClick={
              handleCloseEventModal
            }
            style={{
              background:
                "none",

              border:
                "none",

              color:
                "white",

              fontSize:
                "1.5rem",

              marginLeft:
                "80%",
            }}
          >
            &times;
          </button>
        </Modal.Header>

        <Modal.Body>
          <Tabs
            id="controlled-tab-example"
            activeKey={key}
            onSelect={(k) =>
              setKey(k)
            }
            className="mb-3"
          >
            {/* CASES */}

            <Tab
              eventKey="cases"
              title="Cases"
            >
              <div className="p-3">
                <h5 className="font-bold">
                  New Cases
                </h5>

                <ul>
                  {Array.isArray(
                    casesData
                  ) &&
                    casesData
                      .filter(
                        (
                          caseItem
                        ) => {
                          if (
                            !caseItem
                          ) {
                            return false;
                          }

                          const caseDate =
                            caseItem.date ||
                            caseItem.start_date;

                          return isSameDate(
                            caseDate,
                            selectedEventDate
                          );
                        }
                      )
                      .map(
                        (
                          caseItem,
                          index
                        ) => (
                          <li
                            key={`case-${index}`}
                            onMouseEnter={(e) =>
                              handleMouseEnter(
                                e,
                                caseItem
                              )
                            }
                            onMouseLeave={
                              handleMouseLeave
                            }
                            style={{
                              cursor:
                                "pointer",
                            }}
                          >
                            <Link
                              to={`/case/${caseItem.case_id ||
                                caseItem._id}`}
                              style={{
                                textDecoration:
                                  "none",

                                color:
                                  "inherit",
                              }}
                            >
                              Case{" "}
                              <span
                                style={{
                                  color:
                                    "#004aad",
                                }}
                              >
                                #
                                {caseItem.case_id ||
                                  caseItem._id}
                              </span>
                            </Link>
                          </li>
                        )
                      )}
                </ul>

                <h5 className="font-bold mt-4">
                  Cases Arriving
                </h5>

                <ul>
                  {Array.isArray(
                    casesData
                  ) &&
                    casesData
                      .filter(
                        (
                          caseItem
                        ) => {
                          if (
                            !caseItem ||
                            !caseItem.arrive_date
                          ) {
                            return false;
                          }

                          return isSameDate(
                            caseItem.arrive_date,
                            selectedEventDate
                          );
                        }
                      )
                      .map(
                        (
                          caseItem,
                          index
                        ) => (
                          <li
                            key={`arrive-${index}`}
                            onMouseEnter={(e) =>
                              handleMouseEnter(
                                e,
                                caseItem
                              )
                            }
                            onMouseLeave={
                              handleMouseLeave
                            }
                            style={{
                              cursor:
                                "pointer",
                            }}
                          >
                            <Link
                              to={`/case/${caseItem.case_id ||
                                caseItem._id}`}
                              style={{
                                textDecoration:
                                  "none",

                                color:
                                  "inherit",
                              }}
                            >
                              Case{" "}
                              <span
                                style={{
                                  color:
                                    "#004aad",
                                }}
                              >
                                #
                                {caseItem.case_id ||
                                  caseItem._id}
                              </span>
                            </Link>{" "}
                            to arrive
                          </li>
                        )
                      )}
                </ul>

                <h5 className="font-bold mt-4">
                  Cases Shipping
                </h5>

                <ul>
                  {Array.isArray(
                    casesData
                  ) &&
                    casesData
                      .filter(
                        (
                          caseItem
                        ) => {
                          if (
                            !caseItem ||
                            !caseItem.delivery_date
                          ) {
                            return false;
                          }

                          return isSameDate(
                            caseItem.delivery_date,
                            selectedEventDate
                          );
                        }
                      )
                      .map(
                        (
                          caseItem,
                          index
                        ) => (
                          <li
                            key={`ship-${index}`}
                            onMouseEnter={(e) =>
                              handleMouseEnter(
                                e,
                                caseItem
                              )
                            }
                            onMouseLeave={
                              handleMouseLeave
                            }
                            style={{
                              cursor:
                                "pointer",
                            }}
                          >
                            <Link
                              to={`/case/${caseItem.case_id ||
                                caseItem._id}`}
                              style={{
                                textDecoration:
                                  "none",

                                color:
                                  "inherit",
                              }}
                            >
                              Case{" "}
                              <span
                                style={{
                                  color:
                                    "#004aad",
                                }}
                              >
                                #
                                {caseItem.case_id ||
                                  caseItem._id}
                              </span>
                            </Link>{" "}
                            to ship
                          </li>
                        )
                      )}
                </ul>
              </div>
            </Tab>

            {/* ACTIVITY */}

            <Tab
              eventKey="activity"
              title="Activity"
            >
              <p>
                Activity content
                will go here.
              </p>
            </Tab>

            {/* TASKS */}

            <Tab
              eventKey="tasks"
              title="Tasks"
            >
              <div className="p-3">
                {/* Tasks content */}
              </div>
            </Tab>

            {/* SHIPPING */}

            <Tab
              eventKey="shipping"
              title="Shipping"
            >
              <h5 className="font-bold mt-4">
                Cases Shipping
              </h5>

              <ul>
                {Array.isArray(
                  casesData
                ) &&
                  casesData
                    .filter(
                      (
                        caseItem
                      ) => {
                        if (
                          !caseItem ||
                          !caseItem.delivery_date
                        ) {
                          return false;
                        }

                        return isSameDate(
                          caseItem.delivery_date,
                          selectedEventDate
                        );
                      }
                    )
                    .map(
                      (
                        caseItem,
                        index
                      ) => (
                        <li
                          key={`ship-${index}`}
                          onMouseEnter={(e) =>
                            handleMouseEnter(
                              e,
                              caseItem
                            )
                          }
                          onMouseLeave={
                            handleMouseLeave
                          }
                          style={{
                            cursor:
                              "pointer",
                          }}
                        >
                          <Link
                            to={`/case/${caseItem.case_id ||
                              caseItem._id}`}
                            style={{
                              textDecoration:
                                "none",

                              color:
                                "inherit",
                            }}
                          >
                            Case{" "}
                            <span
                              style={{
                                color:
                                  "#004aad",
                              }}
                            >
                              #
                              {caseItem.case_id ||
                                caseItem._id}
                            </span>
                          </Link>{" "}
                          to ship
                        </li>
                      )
                    )}
              </ul>
            </Tab>
          </Tabs>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default Home;